import { render, staticRenderFns } from "./john-swardson-the-storm.vue?vue&type=template&id=5ed47982&"
import script from "./john-swardson-the-storm.vue?vue&type=script&lang=js&"
export * from "./john-swardson-the-storm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports